module.exports = __webpack_public_path__ + "img/drool_ios_802.png";